import styled from 'styled-components';
import tw from 'twin.macro';

const Container = styled.div`
  ${tw`flex gap-4`}
`;

const Section = styled.div`
  ${tw`flex-1 border border-gray-600 p-4`}
`;

const Title = styled.div`
  ${tw`font-bold mb-4 lowercase`}
`;

const SubSection = styled.div`
  ${tw`mb-4`}
`;

const Text = styled.div`
  ${tw`text-sm`}
`;

const NoticeBox = styled.div`
  ${tw`bg-gray-100 p-4 mb-4 border border-gray-600`}
`;

const Divider = styled.hr`
  ${tw`border-t border-gray-600 my-6`}
`;

const SubSectionWithInlineTitle = styled.div`
  ${tw`mb-4`}
  display: flex;
  gap: 1rem;
`;

const InlineTitle = styled.div`
  ${tw`font-bold`}
  flex-shrink: 0;
`;

const ContentWrapper = styled.div`
  ${tw`flex flex-col gap-2`}
`;

const OtherComponentPageTwo = () => {
  return (
    <Container>
      <Section>
        <SubSectionWithInlineTitle>
          <InlineTitle>f.</InlineTitle>
          <ContentWrapper>
            <Text>
              We will sell the vehicle if you do not get it back. If you do not redeem, we will sell
              the vehicle. We will send you a written notice of sale before selling the vehicle.
            </Text>
            <Text>
              We will apply the money from the sale, less allowed expenses, to the amount you owe.
              Allowed expenses are expenses we pay as a direct result of taking the vehicle, holding
              it, preparing it for sale, and selling it. Attorney fees and court costs the law
              permits are also allowed expenses.
            </Text>
            <Text>
              If any money is left (surplus), we will pay it to you unless the law requires us to
              pay it to someone else. If money from the sale is not enough to pay the amount you
              owe, you must pay the rest to us. If you do not pay this amount when we ask, we may
              charge you interest at the Annual Percentage Rate shown on page 1 of this contract,
              not to exceed the highest rate permitted by law, until you pay.
            </Text>
          </ContentWrapper>
        </SubSectionWithInlineTitle>

        <SubSectionWithInlineTitle>
          <InlineTitle>g.</InlineTitle>
          <ContentWrapper>
            <Text>
              What we may do about optional insurance, maintenance, service, or other contracts.
              This contract may contain charges for optional insurance, maintenance, service, or
              other contracts. If we demand that you pay all you owe at once or we repossess the
              vehicle, you agree that we may claim benefits under these contracts and cancel them to
              obtain refunds of unearned charges to reduce what you owe or repair the vehicle. If
              the vehicle is a total loss because it is confiscated, damaged, or stolen, we may
              claim benefits under these contracts and cancel them to obtain refunds of unearned
              charges to reduce what you owe.
            </Text>
          </ContentWrapper>
        </SubSectionWithInlineTitle>

        <SubSection>
          <Title>4. WARRANTIES SELLER DISCLAIMS</Title>
          <Text>
            If you do not get a written warranty, and the Seller does not enter into a service
            contract within 90 days from the date of this contract, the Seller makes no warranties,
            express or implied, on the vehicle, and there will be no implied warranties of
            merchantability or of fitness for a particular purpose.
          </Text>
          <Text>
            This provision does not affect any warranties covering the vehicle that the vehicle
            manufacturer may provide. If the Seller has sold you a certified used vehicle, the
            warranty of merchantability is not disclaimed.
          </Text>
        </SubSection>

        <SubSection>
          <Title>5. Used Car Buyers Guide</Title>
          <Text>
            The information you see on the window form for this vehicle is part of this contract.
            Information on the window form overrides any contrary provisions in the contract of
            sale.
          </Text>
          <Text>
            Spanish Translation: Guía para compradores de vehículos usados. La información que ve en
            el formulario de la ventanilla para este vehículo forma parte del presente contrato. La
            información del formulario de la ventanilla deja sin efecto toda disposición en
            contrario contenida en el contrato de venta.
          </Text>
        </SubSection>

        <SubSection>
          <Title>6. SERVICING AND COLLECTION CONTACTS</Title>
          <Text>
            In consideration of our extension of credit to you, you agree to provide us your contact
            information for our servicing and collection purposes. You agree that we may use this
            information to contact you in writing, by e-mail, or using prerecorded/artificial voice
            messages, text messages, and automatic telephone dialing systems, as the law allows. You
            also agree that we may try to contact you in these and other ways at any address or
            telephone number you provide us, even if the telephone number is a cell phone number or
            the contact results in a charge to you. You agree to allow our agents and service
            providers to contact you as agreed above.
          </Text>
          <Text>
            You agree that you will, within a reasonable time, notify us of any change in your
            contact information.
          </Text>
        </SubSection>
      </Section>

      <Section>
        <SubSection>
          <Title>7. APPLICABLE LAW</Title>
          <Text>
            Federal law and California law apply to this contract. If any part of this contract is
            not valid, all other parts stay valid. We may delay or refrain from enforcing any of our
            rights under this contract without losing them. For example, we may extend the time for
            making some payments without extending the time for making others.
          </Text>
        </SubSection>

        <SubSection>
          <Title>8. WARRANTIES OF BUYER</Title>
          <Text>
            You promise you have given true and correct information during your application for
            credit, and you have no knowledge that will make that information untrue in the future.
            We have relied on the truth and accuracy of that information in entering into this
            contract. Upon request, you will provide us with documents and other information
            necessary to verify any item contained in your credit application.
          </Text>
        </SubSection>

        <SubSection>
          <Title>9. NEGATIVE CREDIT REPORT NOTICE</Title>
          <Text>
            We may report information about your account to credit bureaus. Late payments, missed
            payments, or other defaults on your account may be reflected in your credit report.
          </Text>
        </SubSection>

        <SubSection></SubSection>
        <Text>
          You waive the provisions of Calif. Vehicle Code Section 1808.21 and authorize the
          California Department of Motor Vehicles to furnish your residence address to us.
        </Text>
        <SubSection>
          <Divider />
          <Title>CREDIT DISABILITY INSURANCE NOTICE CLAIM PROCEDURE</Title>
          <Text>
            If you become disabled, you must tell us right away. (You are advised to send this
            information to the same address to which you are normally required to send your
            payments, unless a different address or telephone number is given to you in writing by
            us as the location where we would like to be notified.) We will tell you where to get
            claim forms. You must send in the completed form to the insurance company as soon as
            possible and tell us as soon as you do.
          </Text>
          <Text>
            If your disability insurance covers all of your missed payments), WE CANNOT TRY TO
            COLLECT WHAT YOU OWE OR FORECLOSE UPON OR REPOSSESS ANY COLLATERAL UNTIL THREE CALENDAR
            MONTHS AFTER your first missed payment is due or until the insurance company pays or
            rejects your claim, whichever comes first. We can, however, try to collect, foreclose,
            or repossess if you have any money due and owing us or a r e otherwise in default when
            your disability claim is made or if a senior mortgage or lien holder is foreclosing.
          </Text>
          <Text>
            If the insurance company accepts your claim within the three calendar months, we must
            allow you to make up your missed payments in 3 equal installments which come due on the
            same day of the month as your original payment. If the insurance company rejects your
            claim within the three calendar months or accepts your claim within the three calendar
            months but requires that you make up past due payments in less than 3 installments, you
            will have 35 days from the date that the rejection or the acceptance of the partial
            disability is sent to pay all missed payments, interest and any delinquency charges. You
            can contact us, and we will tell you how much you owe. After that time, we can take
            action to collect or foreclose or repossess any collateral you may have given.
          </Text>
          <Text>
            If the insurance company accepts your claim but requires that you send in additional
            forms to remain eligible for continued payments, you should send in these completed
            additional forms no later than required. If you do not send in these forms on time, the
            insurance company may stop paying, and we will then be able to take action to collect or
            foreclose or repossess any collateral you may have given.
          </Text>
        </SubSection>
      </Section>
    </Container>
  );
};

export default OtherComponentPageTwo;
